<template>
   <div>Your download will start shortly</div>
</template>

<script>
export default {
    data () {
        return {

        };
    },
    created () {
        const privacyPolicyUrl = this.$store.state.clientConfig.privacyUrl;
        window.location.href = privacyPolicyUrl;
    },
};
</script>

<style lang="scss" scoped>

</style>
